import { ENDPOINTS } from "config/endpoints";
import client from "utils/client";
import { useQuery } from "react-query";
import { Request } from "types/request";
import { Response } from "types/response";
import Error from "types/error";

export default function useUserStorage(enabled = true) {
  const request: Request = {
    url: ENDPOINTS.users.storage,
    config: {
      method: "GET",
    },
  };

  const requestConfig = {
    queryKey: [ENDPOINTS.users.storage],
    queryFn: () => client(request),
    enabled,
  };

  const { data, ...rest } = useQuery<Response<Number>, Error>(requestConfig);

  return { data, ...rest };
}
